import { createSelector } from 'reselect';
import { sortByLabel } from '@/components/SkillsDrawer/utils';

const selectSkillState = (state: DefaultRootState) => state.skills;

export const selectSkills = createSelector(selectSkillState, (skills) => sortByLabel(skills?.list));

export const selectSkillsInitialized = createSelector(selectSkillState, (skills) => !!skills?.initialized);

export const selectSkillsDrawerOpen = createSelector(selectSkillState, (skills) => !!skills?.drawerOpen);
